export const getCardData = [
  { title: 'Compensatory Off', key: 'totalCompensatoryOff' },
  { title: 'Work From Home', key: 'WorkFromHome' },
  { title: 'Leave-Casual Leave', key: 'LeaveCasualLeave' },
  { title: 'Leave-Sick Leave', key: 'LeaveSickLeave' },
  { title: 'Leave-Paid Leave', key: 'LeavePaidLeave' },
  { title: 'Leave-Maternity Leave', key: 'LeaveMaternityLeave' },
  { title: 'Leave Without Pay', key: 'LeaveWithoutPay' },
  { title: 'Leave-Dot Leave', key: 'LeaveDotLeave' },
  { title: 'Leave-Earned Leave', key: 'LeaveEarnedLeave' },
];
